import { animate, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { MatFormField } from '@angular/material/form-field';
import { BehaviorSubject } from 'rxjs';
import { IField } from '../../../models/field/field.model';

@Component({
    selector: 'mat-generic-input-hint',
    templateUrl: './generic-input-hint.component.html',
    styleUrls: [ '../generic-inputs/base-generic-input/base-generic-input.component.scss', './generic-input-hint.component.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        trigger('errorInOut', [
            transition(':enter', [
                style({ height: '15px', opacity: 0 }),
                animate('0.2s', style({ height: '*', opacity: 1 })),
            ]),
            transition(':leave', [
                style({ height: '*', opacity: 1 }),
                animate('0.2s', style({ height: '15px', opacity: 0 })),
            ]),
        ]),
    ],
})
export class GenericInputHintComponent<T, T1> {

    @Input()
    public type: 'error' | 'combined';

    @Input()
    public control: AbstractControl<T>;

    @Input()
    public field: IField;

    @Input()
    public item: MatFormField;

    @Input()
    public selectedIndex: number = 0;

    constructor() {
    }

    public selectValue(data: T1): void {
        (this.field.selectSearchData.selectData.options as BehaviorSubject<unknown[]>).next([]);
        (this.field.selectSearchData.selected as BehaviorSubject<unknown[]>).next(null);
        if (this.field.selectSearchData.selectFunction) {
            this.field.selectSearchData.selectFunction(data, this.control.parent as UntypedFormGroup);
        } else {
            this.control.setValue(data[ this.field.selectSearchData?.selectData?.valueKey ]);
        }
    }

}
